<template>
  <div>
    <Nav ref="Nav" />
    <div class="SeoOrders">
      <div class="SeoOrders_content">
        <div class="SeoOrders_content_title" @click="triggerChildMethod"><span></span>订单详情</div>
        <div class="SeoOrders_content_txt">
          <div class="content_txt_top">
            <div class="txt_top_left">
              <div class="top_left_icon"><img src="@a/seo/sv1.svg" /></div>
              <div class="top_left_con">
                <p>订单名称：购买{{ payInfo?.name }}套餐</p>
                <p>订单类型：<span class="notBlue">新购</span></p>
              </div>
            </div>
            <div class="txt_top_right">
              <p>下单时间：<span>{{ payInfo?.order_time }}</span></p>
              <p>订单编号：<span>{{ payInfo?.order_no }}</span></p>
            </div>
          </div>
          <div class="content_txt_bottom">
            <div class="txt_bottom_list">
              <div class="bottom_list_li">
                <div class="list_li_dd">当前产品</div>
                <div class="list_li_dd">{{ payInfo?.name }}</div>
              </div>
              <div class="bottom_list_li">
                <div class="list_li_dd">购买时间</div>
                <div class="list_li_dd">365天</div>
              </div>
            </div>
            <div class="txt_bottom_list">
              <div class="bottom_list_li">
                <div class="list_li_dd">合计</div>
                <div class="list_li_dd"><b>￥{{ payInfo?.money }}</b></div>
              </div>
            </div>
          </div>
        </div>
        <div class="SeoOrders_content_title"><span></span>支付方式</div>
        <div class="SeoOrders_content_toPay">
          <div class="content_toPay_list">
            <div class="toPay_list_title"><img src="@a/img/sv105.svg" />在线支付</div>
            <div class="toPay_list_txt">
              <div class="list_txt_left"><img :src="payInfo?.images" /></div>
              <div class="list_txt_right">
                <div class="txt_right_dd">应付金额<span>￥{{ payInfo?.money }}</span></div>
                <div class="txt_right_dt"><img src="@a/img/sv23.svg" /><img src="@a/img/sv24.svg" />支持支付宝，微信扫码支付</div>
                <div class="txt_right_p">剩余支付时间<span>23时30分14秒</span>，否则订单将自动取消</div>
              </div>
            </div>
            <div class="toPay_list_bottom">在线支付和对公支付均支持在线申请发票 (对公支付开票发票台头必须和付款账户一致)。</div>
          </div>
          <div class="content_toPay_list">
            <div class="toPay_list_title"><img src="@a/img/sv105.svg" />对公支付</div>
            <div class="toPay_list_bottom">获取对公支付详细信息，支付完成后我们会尽快确认到账并开通服务</div>
            <div class="toPay_list_btn notBlue" @click="alRobotWindow = !alRobotWindow">我要对公支付</div>
          </div>
        </div>
      </div>

      <!-- 对公转账支付流程弹窗 -->
      <div class="alRobotWindow" v-show="alRobotWindow">
        <div class="alRobotWindow_content">
          <div class="alRobotWindow_content_title">
            <div class="content_title_left"><span></span>对公转账支付流程</div>
            <div class="content_title_right" @click="alRobotWindow = !alRobotWindow"><i class="el-icon-close"></i></div>
          </div>
          <div class="alRobotWindow_content_txt">
            <div class="content_txt_title">第一步：对公汇款</div>
            <div class="content_txt_content">
              <p><span>账户名称：</span>上海集锦软件有限公司</p>
              <p><span>开户银行：</span>上海银行股份有限公司彭浦支行</p>
              <p><span>银行账号：</span>31632403003069167</p>
              <p><span>汇款金额：</span>￥{{ payInfo?.money }}</p>
              <p><span>汇款备注：</span>订单号{{ payInfo?.order_no }}</p>
            </div>
            <div class="content_txt_p"><img src="@a/img/sv106.svg" />请在对公汇款时务必备注订单号</div>
            <div class="content_txt_btn"><span class="notBlue" @click="copyLink">一键复制</span></div>
            <div class="content_txt_title">第二步：提交支付凭证</div>
            <div class="content_txt_p2">
              转账完成后，请提供订单号及银行盖章回执单，联系【在线客服】或者发送相关信息至
              <a href="mailto:lynn@jijinweb.com">lynn@jijinweb.com</a>，我们将尽快为您开通/升级产品。
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 支付成功弹窗 -->
    <el-dialog title="支付成功" :visible.sync="dialogVisible" width="30%">
      <span>您的支付已经成功！</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from "element-ui";
import Nav from "@c/common/nav/nav";

export default {
  data() {
    return {
      alRobotWindow: false,
      payInfo: null, // 用来存储接口返回的数据
      dialogVisible: false, // 控制支付成功弹窗显示与否
      pollingInterval: null, // 存储轮询定时器
    };
  },
  components: { Nav },
  watch: {
    // 监听路由变化
    '$route'(to, from) {
      if (to.query.payId !== from.query.payId) {
        this.getPayInfo(); // 当 payId 变化时重新获取数据
      }
    },
  },
  created() {
    this.getPayInfo(); // 组件创建时获取初始数据
    this.startOrderPolling(); // 开始轮询订单状态
  },
  beforeDestroy() {
    clearInterval(this.pollingInterval); // 组件销毁时清除轮询定时器
  },
  methods: {
    // 触发导航栏方法
    triggerChildMethod() {
      this.$refs.Nav.childMethod();
    },

    // 一键复制支付信息
    copyLink() {
      const content = document.querySelector('.content_txt_content');
      const range = document.createRange();
      range.selectNode(content);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      selection.removeAllRanges();
      this.$message({
        message: '已复制',
        type: 'success',
      });
    },

    // 获取支付信息
    async getPayInfo() {
      try {
        const payId = this.$route.query.payId;
        if (!payId) {
          this.$message.error('支付ID不存在');
          return;
        }
        const response = await this.axios.get(`api/products/getAiSeoPayInfo?payId=${payId}`);
        if (response.code === 1) {
          this.payInfo = response.result; // 更新支付信息
          console.log("支付信息:", this.payInfo);
        } else {
          this.$message.error('获取支付信息失败');
        }
      } catch (error) {
        console.error("获取支付信息时出错:", error);
        this.$message.error('请求支付信息失败');
      }
    },

    // 开始订单状态轮询
    startOrderPolling() {
      this.pollingInterval = setInterval(async () => {
        try {
          const res = await this.axios.get(`/api/Seo/hasNewOrder`, {
            params: { order_no: this.payInfo?.order_no },
          });
          if (res.code === 1 && res.result) {
            clearInterval(this.pollingInterval); // 支付成功，停止轮询
            this.axios.get('/api/member/getInfo').then(res => {
              localStorage.setItem('memberInfo', JSON.stringify(res.result));
              this.$store.commit('setMemberInfo', res.result);
            });
            this.dialogVisible = true; // 显示支付成功弹窗
          }
        } catch (error) {
          console.error('请求新订单状态时出错:', error);
        }
      }, 1000); // 每秒轮询一次
    },

    // 关闭支付成功弹窗并跳转
    handleDialogClose() {
      this.dialogVisible = false;
      this.$router.push('/writing/titleGeneration/titleGeneration');
    },
  },
};
</script>

<style>
@import "SeoOrders.css";
</style>